import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { partnerAccountKeys } from './partner-accounts';

export interface ImportSummary {
  parsed: number;
  created: number;
  updated: number;
  unchanged: number;
  skipped: { id: string }[];
  rejected: { id: string; reason: string }[];
  failed: { id: string; reason: string }[];
  disappeared: string[];
  rejectedImageUrls: { id: string; url: string }[];
}

export function useImportFile(accountId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (records: unknown[]): Promise<{ success: boolean; summary: ImportSummary }> =>
      api.post<{ success: boolean; summary: ImportSummary }>(
        `/api/v1/partner-accounts/${accountId}/import-file`,
        { records },
      ),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: partnerAccountKeys.detail(accountId) }); },
  });
}
